/* eslint-disable max-len */
import React, { Fragment } from 'react'
import Pagination from '../../../../components/Pagination';
import { formatAdjustedDate } from '../../../../CommonMethods/formatDate';

const Table = ({InventoryIssueReportStudentList,
    searchParams,
    setSearchParams,
    setPageLoading,
    reportTotal,
    handleOnClickSort,
    sortValue,
    startDate,
    issueReportTotal,
    endDate,
    InventoryIssueReportStudentCount}) => {
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const urlParams = new URLSearchParams(window.location.search);

    const branchUrl = urlParams.get("sort");
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }
    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;
    const handleSort = (key) => {
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
    return (
        <div class="-mx-1">
            <div className='text-center absolute w-full'>Issued Date from <span className="font-semibold">{searchParams?.get('start_date') === null ? formatAdjustedDate(startDate) : formatAdjustedDate(searchParams?.get('start_date'))}</span> to <span className="font-semibold">{searchParams?.get('end_date') === null ? formatAdjustedDate(endDate, true) : formatAdjustedDate(searchParams?.get('end_date'))}</span></div>
            <div class="flex overflow-auto pb-[6px] scroll-bar px-1 topHeading" id="search-result">
                <table aria-label="Outside Table" class="w-full " id="admin-table">
                    <thead>
                        <tr>
                            <th id= "Issued Date" class="w-[15%]" onClick={() => {handleSort('invoice_date')}}>
                                <span >Issued Date
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "invoice_date" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span >Invoice #
                                </span>
                            </th>
                            <th id="Student Name" class="w-[25%]" onClick={() => {handleSort('student_name')}}>
                                <span >Student Name
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "student_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th id="Item Code" class="w-[13%]" onClick={() => {handleSort('line_item')}}>
                                <span >Item Code
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "line_item" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th id="Item Name" class="w-[13%]" onClick={() => {handleSort('item_name')}}>
                                <span >Item Name
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "item_name" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span class="flex items-center justify-end">Issued Qty
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span class="flex items-center justify-end">Item price
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span class="flex items-center justify-end">Total price
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>
                    </thead>
                    <tbody >
                        {InventoryIssueReportStudentList?.map((inventory) => (
                            <>
                                <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                <tr class="group">
                                    <td class=" text-start">{formatAdjustedDate(inventory?.invoice_date)}</td>
                                    <td class=" text-start">{inventory?.invoice_number}</td>
                                    <td class="text-start">{inventory?.student_name + ' [' + inventory?.student_id+']'}</td>

                                    <td class="text-start  capitalize">{inventory?.line_item}</td>
                                    <td class="text-start">{inventory?.item_name}</td>

                                    <td class="text-end">{inventory?.issue_quantity}</td>
                                    <td class="text-end">{parseFloat(inventory?.item_price).toFixed(2)}</td>
                                    <td class="text-end">{parseFloat(inventory?.total_line_amount).toFixed(2)}</td>
                                </tr>
                            </>))}
                        { InventoryIssueReportStudentCount > 0 &&
                            <>
                                <tr id="list-items" aria-colspan="7" class="relative h-0.5 z-[-10]"></tr>
                                <tr class="group">
                                    <td class=" font-semibold text-start" colSpan={5}>
                                        <p>Report Total</p>
                                    </td>
                                    <td class="font-semibold text-end">
                                        <p>{issueReportTotal}</p>
                                    </td>
                                    <td class="pl-3 pr-6 py-[15px] text-f2 text-[#031624] font-semibold text-end " colSpan={2}>
                                        <p>{parseFloat(reportTotal).toFixed(2)}</p>
                                    </td>
                                </tr>
                            </>
                        }   
                    </tbody>
                    {InventoryIssueReportStudentCount === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No Inventory issued yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
            {InventoryIssueReportStudentCount > 10 &&  <Pagination
                TotalCount={InventoryIssueReportStudentCount}
                totalPageNumber={Math?.ceil(InventoryIssueReportStudentCount / 10)}
                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                handleOnClickPageNumber={handleOnClickPageNumber}
            />}
        </div>

    )
}
export default Table;   